module.exports = __webpack_public_path__ + "img/img-search07.7003d25e.jpg";